(function ($) {

  // SCROLL TO SECTION

  function scrollTo(link) {
    // event.preventDefault();

    var root = $('html, body');
    var href = $(link).attr('href');
    root.animate({
      scrollTop: $(href.substring(href.indexOf('#'))).offset().top - 100
    }, 500);
  }

  $('.subscription-btn a').on('click', function(){
    scrollTo(this);
  });

  $('.subscription-card a.incartsimple').click(function (e) {
    e.preventDefault();
    var productId = $(this).data('productid');
    var quantity = 1;
    $.ajax({
      url: ajaxurl,
      type: 'post',
      data: {action: 'cartadd', productid: productId, c: quantity},
      success: function (data) {
        window.location.href = carturl;
      }
    });
  });


})(jQuery);

